import React from 'react';
import { LoadingLines } from '@gik/ui/LoadingLines/LoadingLines';

export interface InkindTileProps {
  title?: string;
  thumbnail?: string;
  location?: string;
  loading?: boolean;
  onClick?: () => void;
}

export const InkindTile: React.FunctionComponent<InkindTileProps> = props => {
  // TODO: fix the root url of images
  const backgroundImage = {
    backgroundImage: `url(${process.env.BASE_URL}/${props.thumbnail})`,
  };

  const className = props.onClick ? 'gik-inkind-tile gik-inkind-tile--clickable' : 'gik-inkind-tile';

  return (
    <div className={className} onClick={props.onClick}>
      <div className="gik-inkind-tile__content">
        {props.loading && (
          <React.Fragment>
            <div className="gik-inkind-tile__thumbnail gik-inkind-tile--loading"></div>
            <div className="gik-inkind-tile__loading-block">
              <LoadingLines />
            </div>
          </React.Fragment>
        )}
        {props.thumbnail && <div className="gik-inkind-tile__thumbnail" style={backgroundImage}></div>}
        {props.title && <div className="gik-inkind-tile__title">{props.title}</div>}
        {props.location && <div className="gik-inkind-tile__location">{props.location}</div>}
      </div>
    </div>
  );
};
